import { Suspense } from 'react';
import { Redirect, Route, Switch } from 'react-router-dom';

import Error404 from '~/layout/components/Error404';

import AppSpinner from 'components/AppSpinner';
import { OWN_DASHBOARD } from 'constants/featureToggle';
import { useAppSelector } from 'store';

import AuthGuard from './AuthGuard';
import PageViewTracker from './PageViewTracker';
import { getPublicRoutes, getProtectedRoutes } from './routes';

const AppRoutes = () => {
  const ownersPortalSettings = useAppSelector(
    (state) => state.user.ownersPortalSettings
  );
  const isOwnDashboardFTEnabled =
    window.featureToggle?.isEnabled(OWN_DASHBOARD);

  return (
    <Suspense fallback={<AppSpinner />}>
      <Switch>
        {getPublicRoutes({ ownersPortalSettings }).map((route) => (
          <Route
            key={route.path}
            exact
            path={route.path}
            render={(props) => (
              <AuthGuard requireAuth={false}>
                <route.component {...props} />
              </AuthGuard>
            )}
          />
        ))}

        {getProtectedRoutes({ ownersPortalSettings }).map((route) => (
          <Route
            key={route.path}
            exact
            path={route.path}
            render={(props) => (
              <AuthGuard requireAuth>
                <route.component {...props} />
                <PageViewTracker />
              </AuthGuard>
            )}
          />
        ))}

        <Route exact path="/404" component={Error404} />

        <Redirect
          key="/"
          exact
          from="/"
          to={{
            pathname: isOwnDashboardFTEnabled ? '/dashboard' : '/my-properties',
            state: { from: '/' },
          }}
        />

        <Redirect key="*" to="/404" />
      </Switch>
    </Suspense>
  );
};

export default AppRoutes;
